import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CaseEndpoint } from './case-endpoint.service';
import { CaseViewModel, RollbackCaseStageRequestData, AssignCaseOwnershipRequest } from '../../models/case';

@Injectable({
    providedIn: 'root'
})
export class CaseService {

    constructor(private caseEndpoint: CaseEndpoint) { }

    public addCase(base64: string, type: string, context?: {}): Observable<CaseViewModel> {
        return this.caseEndpoint.addCase(base64, type, context);
    }

    // public getCurrentCases(base64): Observable<CaseViewModel[]> {
    //     return this.caseEndpoint.getCurrentCasesEndpoint<CaseViewModel[]>(base64);
    // }

    public getCurrentCaseByCategory(base64, productCategory: string): Observable<CaseViewModel> {
        return this.caseEndpoint.getCurrentCaseByCategoryEndpoint(base64, productCategory);
    }

    public getCaseRawDetails(tenantId: string, caseId: number) {
        return this.caseEndpoint.getCaseRawDetails(tenantId, caseId);
    }

    public getCasesByCategory(base64, productCategory: string): Observable<CaseViewModel[]> {
        return this.caseEndpoint.getCasesByCategoryEndpoint(base64, productCategory);
    }

    public advanceStage(base64: string, orchestrationExternalId: string, actionId: string, payLoad: { [key: string]: any }) {
        return this.caseEndpoint.advanceStageEndpoint(base64, orchestrationExternalId, actionId, payLoad);
    }

    public rollbackCaseStage(rollbackCaseStageRequestData: RollbackCaseStageRequestData) {
        return this.caseEndpoint.rollbackCaseStage(rollbackCaseStageRequestData);
    }

    public assignCaseOwnership(assignCaseOwnershipRequest: AssignCaseOwnershipRequest) {
        return this.caseEndpoint.assignCaseOwnership(assignCaseOwnershipRequest);
    }

    updateCaseCustomData(base64: string, caseExternalId: string, metadata: any) {
        return this.caseEndpoint.updateCaseCustomData(base64, caseExternalId, metadata);
    }

}
